import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import fallbackVideos from "../data/videoLinks.json"; // Import fallback JSON file

export const VideoContext = createContext();

const VideoProvider = ({ children }) => {
  const [leftVideoIds, setLeftVideoIds] = useState(fallbackVideos.leftVideoIds); // Default to fallback videos
  const [rightVideoIds, setRightVideoIds] = useState(fallbackVideos.rightVideoIds);

  const fetchVideosFromRSS = async () => {
    try {
      const rssUrl = `https://www.youtube.com/feeds/videos.xml?channel_id=UCMJeoG6jGrGtk3noLZ6bJMg`;
      
      const response = await axios.get(rssUrl, {
        headers: {
          "Content-Type": "application/xml"
        }
      });

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(response.data, "application/xml");
      const videoEntries = xmlDoc.getElementsByTagName("entry");

      const videoIds = [];
      for (let i = 0; i < videoEntries.length; i++) {
        const videoId = videoEntries[i].getElementsByTagName("id")[0].textContent.split(":")[2];
        videoIds.push(videoId);
      }

      if (videoIds.length >= 20) {
        setLeftVideoIds(videoIds.slice(0, 10));
        setRightVideoIds(videoIds.slice(10, 20));
      } else {
        throw new Error("Insufficient videos in RSS feed");
      }
    } catch (error) {
      console.error("Error fetching YouTube RSS feed:", error);
      console.warn("Loading fallback video IDs from JSON file...");
      
      // Load fallback video IDs
      setLeftVideoIds(fallbackVideos.leftVideoIds);
      setRightVideoIds(fallbackVideos.rightVideoIds);
    }
  };

  // Fetch video IDs on initial load and refresh every 24 hours
  useEffect(() => {
    fetchVideosFromRSS();
    const interval = setInterval(fetchVideosFromRSS, 24 * 60 * 60 * 1000); // Refresh every 24 hours

    return () => clearInterval(interval); // Cleanup when unmounting
  }, []);

  return (
    <VideoContext.Provider value={{ leftVideoIds, rightVideoIds, refreshVideos: fetchVideosFromRSS }}>
      {children}
    </VideoContext.Provider>
  );
};

export default VideoProvider;
